import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import {
  fontFamily,
  fontSize,
  fontsWeight,
} from '@/shahrzad-assets/shared-constants/fonts'
import { Checkbox, Col, Row } from 'antd'
import { Breakpoint } from 'react-socks'
import { styled } from 'styled-components'
import CustomLoginCarousel from '@/shahrzad-assets/shared_components/otp/CustomLoginCarousel'
import LegalForm from './LegalForm'

const SignUpSmallUp = () => {
  return (
    <>
      <Breakpoint small medium up>
        <Container align={'middle'}>
          <Row>
            <Col span={2}> </Col>
            <Col span={10}>
              <FormContainer>
                <Title>ثبت نام کاربر حقوقی</Title>
                <Description>اطلاعات زیر را کامل کنید</Description>
                <LegalForm />
              </FormContainer>
            </Col>
            <Col span={2}> </Col>
            <CustomCol span={10}>
              <CustomLoginCarousel />
            </CustomCol>
          </Row>
        </Container>
      </Breakpoint>
    </>
  )
}

export default SignUpSmallUp

const Container = styled(Row)`
  min-height: 100vh;
  height: auto;
`

const FormContainer = styled.div`
  padding: ${dimens.SPACING_XXXL} 0;
`

const Title = styled.p`
  font-weight: ${fontsWeight.MEDIUM};
  margin-bottom: ${dimens.SPACING_XS};
`

const Description = styled.p`
  font-size: ${fontSize.NORMAL};
  margin-bottom: ${dimens.SPACING_XL};
`

const CustomCol = styled(Col)`
  display: flex;
  flex-direction: column;
`
